import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';

import './index.module.less';

import FridayService from '@services/friday';
import NativeInterface from '@helpers/NativeInterface';
import { commandMessage, isCubeApp } from '@helpers/Constants';

import NavBar from '@components/NavBar';
import CommonBtn from '@components/CommonBtn';

const indexTitle = ['一', '二', '三', '四', '五'];

interface IProps {
  onClose?: () => void;
  eventCodes: string[];
}

const Error = (props: IProps) => {
  const { eventCodes = [] } = props;

  useEffect(() => {
    let typeText = '';
    typeText = eventCodes.join('、');
    FridayService.addEvent(
      'account_cancellation_logout_failed_page_page_itself_display',
      { type: typeText },
    );
  }, [eventCodes]);

  const goBack = () => {
    props.onClose && props.onClose();
  };

  const confirm = async () => {
    if (isCubeApp()) {
      NativeInterface.postMessage(commandMessage.closeContainer);
    }
    const isMiniProgram = window?.__wxjs_environment === 'miniprogram';
    if (isMiniProgram) {
      window.wx.miniProgram.navigateBack();
    }
  };

  return ReactDOM.createPortal(
    <div styleName="error">
      <NavBar
        title="注销失败"
        onClickBackBtn={goBack}
        hideBackButton={window?.__wxjs_environment === 'miniprogram'}
      />
      <div className="flex" styleName="tip">
        <i className="iconfont icon-cuowu" />
        <span styleName="tip-title">注销失败</span>
        <span styleName="tip-desc">由于以下原因，导致注销失败</span>
      </div>
      <div styleName="reason-title">
        主要原因
        <div styleName="reason-title-block"></div>
      </div>
      {eventCodes.map((item, index) => {
        return (
          <div styleName="explanation" key={index}>
            <div styleName="explanation-title">
              <span styleName="explanation-title-text">
                原因{indexTitle[index]}：
              </span>
              {item}
            </div>
          </div>
        );
      })}
      <CommonBtn type="fixed" btnText="返回" onConfirm={confirm} />
    </div>,
    document.getElementById('modal') as HTMLDivElement,
  );
};

export default Error;
